import { createFileRoute } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";
import { McpSettingsPage } from "src/pages/McpSettingsPage";
import { mcpConnectionsQueryOptions } from "src/queries/mcp";

export const Route = createFileRoute("/_auth/_coach/orgs/$slug/settings/mcp")({
  component: McpSettingsPage,
  ssr: true,
  loader: async ({ context }) => {
    return loaderHandler(async () => {
      await context.queryClient.query({
        ...mcpConnectionsQueryOptions(),
        staleTime: "static",
      });
      return { data: null };
    });
  },
});
